import { Component, effect, HostListener, inject, OnInit, signal } from '@angular/core';
import { TranslatePipe } from '@codeandweb/ngx-translate';
import { AppService } from '../../../services/app.service';
import { NewsItem, NewsList } from '../../../interfaces/app.interface';
import { Tab, TabList, Tabs } from 'primeng/tabs';
import { DatePipe } from '@angular/common';
import { LanguageType } from '../../../enum/app.enum';
import { Button } from 'primeng/button';
import { NgxFlickingComponent, NgxFlickingPanel } from '@egjs/ngx-flicking';
import { NewsDatePipe } from '../../../pipes/news-date.pipe';

@Component({
  selector: 'app-news',
  imports: [
    TranslatePipe,
    Tabs,
    TabList,
    Tab,
    DatePipe,
    Button,
    NgxFlickingPanel,
    NgxFlickingComponent,
    NewsDatePipe,
  ],
  templateUrl: './news.html',
  styleUrl: './news.scss',
  standalone: true,
})
export class News implements OnInit {
  public appService = inject(AppService);
  public newsList: NewsList[] = [];
  public selectedYear = signal<number>(0);
  public displayedNews: NewsItem[] = [];
  public displayedNewsForDesktop: NewsItem[] = [];
  public flickingOptions = {
    circular: false,
    align: 0,
    bound: true,
    inputType: ['touch', 'mouse', 'pointer'],
  };
  protected readonly LanguageType = LanguageType;

  constructor() {
    effect(() => {
      const selectedYear = this.selectedYear();

      const data = this.newsList.find((item) => item.year === selectedYear);
      if (data?.list) {
        this.displayedNews = data.list;
        this.displayedNewsForDesktop = this.displayedNews.slice(0, this.getColumnsPerRow());
      }
    });

    effect(async () => {
      const language = this.appService.usedLanguage();
      await this.getNewsList();

      const data = this.newsList.find((item) => item.year === this.selectedYear());
      if (data?.list) {
        this.displayedNews = data.list;
        this.displayedNewsForDesktop = this.displayedNews.slice(0, this.getColumnsPerRow());
      }
    });
  }

  @HostListener('window:resize')
  onResize() {
    if (window.innerWidth < 768) return;
    const cols = this.getColumnsPerRow();
    const displayed = this.displayedNewsForDesktop;

    if (displayed.length % cols !== 0) {
      const needed = cols - (displayed.length % cols);
      this.displayedNewsForDesktop = this.displayedNews.slice(
        0,
        this.displayedNewsForDesktop.length + needed >= this.displayedNews.length
          ? this.displayedNews.length
          : this.displayedNewsForDesktop.length + needed,
      );
    }
  }

  async ngOnInit() {
    await this.getNewsList();
    this.selectedYear.set(this.newsList[0].year);
  }

  async getNewsList() {
    const data: NewsItem[] | null = await this.appService.getNewsList();

    if (data) {
      this.newsList = Object.values(
        data.reduce<Record<number, NewsList>>((acc, item) => {
          if (item.status !== 'publish') return acc;

          const year = new Date(item.newsDate).getFullYear();

          if (!acc[year]) {
            acc[year] = { year, list: [] };
          }
          acc[year].list.push({
            ...item,
          });

          return acc;
        }, {}),
      ).sort((a, b) => b.year - a.year);
    }
  }

  clickYear(year: number) {
    this.selectedYear.set(year);
  }

  getColumnsPerRow(): number {
    if (window.innerWidth <= 1024) return 3;
    return 4;
  }

  getMoreNews() {
    this.displayedNewsForDesktop = this.displayedNews.slice(
      0,
      this.displayedNewsForDesktop.length + this.getColumnsPerRow() * 2 >= this.displayedNews.length
        ? this.displayedNews.length
        : this.displayedNewsForDesktop.length + this.getColumnsPerRow() * 2,
    );
  }
}
